// extracted by mini-css-extract-plugin
module.exports = {"container":"LocalizationPreview_container__1Cv49","dummy":"LocalizationPreview_dummy__3yBz5"};